/**
 * 時間帯枠 Value Object
 */
export interface TimeSlot {
  id: string;
  startTime: string;               // HH:mm
  endTime: string;                 // HH:mm
  recruitmentSlots: number;        // 募集医師枠数
  recruitedSlots: number;          // 募集済み枠数
  totalReservationSlots: number;   // 診療予約枠(合計)
  urgentSlots: number;             // 急募医師枠数
  confirmedSlots: number;          // 確定医師枠数
  shortageSlots: number;           // 不足医師枠数
}

/**
 * 時間帯定義型
 */
export interface TimeSlotDefinition {
  start: string;
  end: string;
}

/**
 * 時間帯定義（07:00〜23:00、計16時間帯）
 */
export const TIME_SLOTS: readonly TimeSlotDefinition[] = [
  { start: '07:00', end: '08:00' },
  { start: '08:00', end: '09:00' },
  { start: '09:00', end: '10:00' },
  { start: '10:00', end: '11:00' },
  { start: '11:00', end: '12:00' },
  { start: '12:00', end: '13:00' },
  { start: '13:00', end: '14:00' },
  { start: '14:00', end: '15:00' },
  { start: '15:00', end: '16:00' },
  { start: '16:00', end: '17:00' },
  { start: '17:00', end: '18:00' },
  { start: '18:00', end: '19:00' },
  { start: '19:00', end: '20:00' },
  { start: '20:00', end: '21:00' },
  { start: '21:00', end: '22:00' },
  { start: '22:00', end: '23:00' },
] as const;

/**
 * カレンダーデフォルト表示時間帯（3つ）
 */
export const DEFAULT_DISPLAY_TIME_SLOTS: readonly TimeSlotDefinition[] = [
  { start: '07:00', end: '08:00' },
  { start: '08:00', end: '09:00' },
  { start: '09:00', end: '10:00' },
] as const;
